// startup
// Load entry module
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./src/index.tsx");
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?http://0.0.0.0:443");
